// extracted by mini-css-extract-plugin
module.exports = {"root":"Nav_root__o9yYD","nav_button":"Nav_nav_button__2posH","left_content":"Nav_left_content__352DM","drawer_item":"Nav_drawer_item__1EQ_3","logo":"Nav_logo__DLlLt"};